function collectMemberCallUsageFactory(object, property) {
  return function collectMemberCallUsage(usage, node, parent) {
    if (node.name === object) {
      const memberParent = parent[parent.length - 1];
      const callParent = parent[parent.length - 2];
      if ((callParent === null || callParent === void 0 ? void 0 : callParent.node.type) === "CallExpression" && (callParent === null || callParent === void 0 ? void 0 : callParent.key) === "callee" && (memberParent === null || memberParent === void 0 ? void 0 : memberParent.node.type) === "MemberExpression" && memberParent.key === "object" && (memberParent.node.computed ? memberParent.node.property.type === "Literal" && memberParent.node.property.value === property : memberParent.node.property.type === "Identifier" && memberParent.node.property.name === property)) {
        const args = callParent.node.arguments;
        if (args.length > 0) {
          const firstArg = args[0];
          if (firstArg.type === "Literal" && typeof firstArg.value === "string") {
            usage.usedArgs.add(firstArg.value);
          } else {
            usage.hasNonStaticUsage = true;
          }
        }
      }
    }
  };
}
export const collectAppGetMenuUsage = collectMemberCallUsageFactory("APP", "getMenu");
export const collectInstalledAppsHasUsage = collectMemberCallUsageFactory("INSTALLED_APPS", "has");
//# sourceMappingURL=collectMemberCallUsage.js.map